<template>
  <div class="stats">
    <div class="stat"><div class="num">{{ c10 }}+</div><div class="label">年政企服务经验</div></div>
    <div class="stat"><div class="num">{{ c3a }}</div><div class="label">大核心能力底盘</div></div>
    <div class="stat"><div class="num">{{ c3b }}</div><div class="label">大核心业务赛道</div></div>
    <div class="stat"><div class="num">{{ c100 }}+</div><div class="label">政企客户信赖</div></div>
  </div>
</template>
<script>
export default {
  name: 'StatsBar',
  data(){ return { c10:0, c3a:0, c3b:0, c100:0 } },
  mounted(){
    this.anim(10,'c10',800); this.anim(3,'c3a',600)
    this.anim(3,'c3b',600); this.anim(100,'c100',1000)
  },
  methods:{
    anim(t,k,d){
      const s=t/(d/16); const i=setInterval(()=>{
        this[k]=Math.min(Math.ceil(this[k]+s),t)
        if(this[k]>=t) clearInterval(i)
      },16)
    }
  }
}
</script>
<style scoped>
.stats { border-top:1px solid var(--h25-border); border-bottom:1px solid var(--h25-border); padding:44px 0; display:flex; justify-content:center; gap:88px; flex-wrap:wrap; }
.stat { text-align:center; }
.num { font-size:46px; font-weight:700; color:var(--h25-text); letter-spacing:-1px; }
.label { font-size:13px; color:var(--h25-muted); margin-top:4px; }
</style>
